import {
  loadCurCard,
  loadCurOrder,
  loadCurOrg,
  loadCurPac,
  loadCurrentCity,
  loadInvoice
} from '../assets/js/cache'
/* 初始状态 */
const state = {
  user: {},
  family: {},
  comefrom: null, // 第三方跳转信息
  currentCity: loadCurrentCity(),
  currentOrg: loadCurOrg(),
  currentPac: loadCurPac(),
  currentOrder: loadCurOrder(),
  currentCard: loadCurCard(),
  invoiceType: loadInvoice(),
  // currentOrderType: loadCurOrderType(),
  packageOrReqs: [],
  additionStatusBarData: [],
  agreeCMBExplain: 0, // 是否投保，提交订单和同意协议上设置
  ccbDiscount: sessionStorage.getItem('ccbDiscount') || false,
  subTitle: '',
  newMessagePrompt: null,
  previewList: [],
  defaultFormData:{
      name:'',
      mobile:'',
      certNo:''
  }
}

export default state
